import { z } from 'zod';

export type LoginSchemaMessages = {
  emailRequired: string;
  emailInvalid: string;
  passwordRequired: string;
  passwordMin: string;
};

const defaultLoginMessages: LoginSchemaMessages = {
  emailRequired: 'Email is required',
  emailInvalid: 'Please enter a valid email address',
  passwordRequired: 'Password is required',
  passwordMin: 'Password must be at least 6 characters',
};

export function createLoginSchema(messages: LoginSchemaMessages) {
  return z.object({
    email: z.string().min(1, messages.emailRequired).email(messages.emailInvalid),
    password: z
      .string()
      .min(1, messages.passwordRequired)
      .min(6, messages.passwordMin),
  });
}

/** Default English schema (e.g. API typing). Prefer `createLoginSchema` in UI for i18n. */
export const loginSchema = createLoginSchema(defaultLoginMessages);

export type LoginSchema = z.infer<typeof loginSchema>;
